import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import InfoBox from './InfoBox'

const TabSwitch = (props) => {
  const { tabSwitch, setTabSwitch, options, disabled = false, translationKey = null, classNames = '', style = {} } = props
  const { t } = useTranslation()

  // return
  return (
    <InfoBox
      body={t('Tips.Recommendations.CreativeComposer.mediaSwitchDisabled.body')}
      enabled={disabled}
      withAnchor={false}
      classNames="d-inline-block"
    >
      <div className={`tab-switch ${classNames} ${disabled ? 'disabled' : ''}`} style={style}>
        {options.map((option) => (
          <button 
            type="button"
            key={option} 
            onClick={() => setTabSwitch(option)}
            className={`tab-switch_button ${tabSwitch === option ? 'active' : ''}`}
            disabled={disabled}
          >
            {translationKey ? t(`${translationKey}.${option}`) : option}
          </button>
        ))}
      </div>
    </InfoBox>
  )
}

export default TabSwitch

TabSwitch.propTypes = {
  tabSwitch: PropTypes.string.isRequired,
  setTabSwitch: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
}